module.exports = __webpack_public_path__ + "static/img/user_5.84092d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_5.png
// module id = we1H
// module chunks = 0